import { apiConfig, createAxiosServiceInstance } from '../api';
import {
  AMLS_COMMON,
  AMLS_NS_IAD,
  AMLS_NS_COMMON
} from '../../pages/constants/globalConstants';

const axios = createAxiosServiceInstance();

const headers = {
  'Content-Type': 'application/json'
};

const baseURL = `${apiConfig.serviceApi}`;
const ticketBaseURL = baseURL + AMLS_COMMON + '/tickets';
const currentChampionURL =
  baseURL + AMLS_NS_IAD + '/runInstance/currentChampionId';

export async function postCreateTicketForChampionService(payload) {
  return await axios.post(ticketBaseURL, payload, { headers }).then((res) => {
    return res;
  });
}

export async function getCurrentChampionService(payload) {
  const params = {
    sourceId: payload
  };
  return await axios
    .get(currentChampionURL, { headers, params })
    .then((res) => {
      return res;
    });
}
